import { createAction } from 'redux-actions';
export var SET_CURRENT_LEG = 'SET_CURRENT_LEG';
export var GO_TO_NEXT_LEG = 'GO_TO_NEXT_LEG';
export var setCurrentLeg = createAction(SET_CURRENT_LEG, function (legId) { return legId; });
export var goToNextLeg = createAction(GO_TO_NEXT_LEG);
